const imageExt = ref('webp')

export function getContentfulImageExt (src) {
  let ext = ''
  let prefix = '?'

  if (src.includes('ctfassets')) {
    if (src.includes('?w=')) {
      prefix = '&'
    }
    ext = `${prefix}fm=${imageExt.value}`
  }

  return src + ext
}

export function webpChecker () {
  onBeforeMount(async () => {
    if (!self.createImageBitmap) {
      imageExt.value = 'png'
      return
    }

    const webpData = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA='
    const blob = await fetch(webpData).then(r => r.blob())
    imageExt.value = await createImageBitmap(blob).then(() => 'webp', () => 'png')
  })

  return {
    imageExt
  }
}
